






















































import { Component, Mixins } from 'vue-property-decorator';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GExamDetailCircleChart from '@/views/GExamDetail/GExamDetailProgressChart.vue';
import { GPageBase } from '@/mixins';
import GExamDetailClassProgressCharts from '@/views/GExamDetail/GExamDetailProgressClassCharts.vue';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import GExamDetailProgressClassTable from '@/views/GExamDetail/GExamDetailProgressClassTable.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GSubTitleBar from '@/components/GSubTitleBar.vue';
import GExamDetailProgressOverallCharts from '@/views/GExamDetail/GExamDetailProgressOverallCharts.vue';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';

@Component({
  name: 'GExamDetailProgress',
  components: { GExamDetailProgressOverallCharts, GSubTitleBar, GTitleBar, GExamDetailProgressClassTable, GExamDetailClassProgressCharts, GExamDetailCircleChart },
  computed: {},
  methods: {},
})
export default class GExamDetailProgress extends Mixins(GPageBase) {
  lazy: boolean = false;
  selectedSchoolClassID: number = 0;
  selectedGrade: number = 0;

  mounted() {
    if (this.examineeSchoolClassesByGrade.length > 0) {
      this.selectedGrade = this.examineeSchoolClassesByGrade[0].grade;
      this.selectedSchoolClassID = this.examineeSchoolClassesByGrade[0].schoolClasses[0].schoolClassID;
    }
    this.lazy = true;
  }

  get examineeStudentProgresses(): ExamineeStudentProgress[] {
    return evalSettingDetailModule.examineeStudentProgresses;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get examineeSchoolClassesByGrade(): GradeSchoolClass[] {
    return evalSettingDetailModule.examineeSchoolClassesByGrade;
  }

  handleDownloadProgressExcel() {
    this.isRunning = true;
    evalSettingDetailModule.setIsDownloadProgressRunning(true);
    evalSettingDetailModule.downloadProgress(this.evalSettingDetail).then(() => {
      this.isRunning = false;
      evalSettingDetailModule.setIsDownloadProgressRunning(false);
    });
  }

  handleSelectClass(index: number, gradeSchoolClass: GradeSchoolClass) {
    evalSettingDetailModule.setSelectedSchoolClassID(gradeSchoolClass.schoolClasses[index].schoolClassID);
    this.selectedSchoolClassID = gradeSchoolClass.schoolClasses[index].schoolClassID;
  }

  handleSelectGrade(index: number) {
    if (index === 0) {
      return;
    }
    const adjIndex = index - 1;
    if (this.examineeSchoolClassesByGrade[adjIndex].grade !== this.selectedGrade) {
      // すでに開いているタブをクリック時は何もしない
      evalSettingDetailModule.setSelectedGrade(this.examineeSchoolClassesByGrade[adjIndex].grade);
      evalSettingDetailModule.setSelectedSchoolClassID(this.examineeSchoolClassesByGrade[adjIndex].schoolClasses[0].schoolClassID);

      this.selectedSchoolClassID = this.examineeSchoolClassesByGrade[adjIndex].schoolClasses[0].schoolClassID;
      this.selectedGrade = this.examineeSchoolClassesByGrade[adjIndex].grade;
    }
  }

  overallProgressTab(): any {
    const examineeProgressOverall: ExamineeStudentProgress[] = evalSettingDetailModule.examineeStudentProgresses;
    const progressPercent: number = this.percentFloor(examineeProgressOverall.filter((v: ExamineeStudentProgress) => v.isStatusCompleted).length / examineeProgressOverall.length);
    return this.progressTag(this.$t('OVERALL').toString(), progressPercent);
  }

  gradeProgressTab(grade: number): any {
    const examineeProgressByGrade: ExamineeStudentProgress[] = evalSettingDetailModule.examineeStudentProgressesByGrade.get(grade);
    const progressPercent: number = this.percentFloor(examineeProgressByGrade.filter((v: ExamineeStudentProgress) => v.isStatusCompleted).length / examineeProgressByGrade.length);
    return this.progressTag(`${this.$t('NUMBER_YEAR', {value: grade}).toString()}`, progressPercent);
  }

  classProgressTab(schoolClass: SchoolClass): any {
    const examineeProgressBySchoolClassID: ExamineeStudentProgress[] = evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.get(schoolClass.schoolClassID);
    const progressPercent: number = this.percentFloor(examineeProgressBySchoolClassID.filter((v: ExamineeStudentProgress) => v.isStatusCompleted).length / examineeProgressBySchoolClassID.length);
    return this.progressTag(schoolClass.schoolClassName, progressPercent);
  }

  percentFloor(ratio: number): number {
    return Math.floor(ratio * 100);
  }

  progressTag(tabTitle: string, progressPercent: number): any {
    return (h: any) => {
      return h(
        'div',
        {
          style: {
            fontSize: '16px',
            'margin-bottom': '10px',
          },
        },
        [
          h(
            'span',
            {
              style: {
                'margin-right': '20px',
              },
            },
            tabTitle
          ),
          h(
            'Tag',
            {
              props: {
                color: 'red',
              },
            },
            `${progressPercent}%`
          ),
        ]
      );
    };
  }
}
